import { SHA256 } from "crypto-js"

// inspired by source at: https://github.com/Rajesh-Royal/Broprint.js/

const isCanvasSupported = () => {
    const elemement = document.createElement("canvas")

    return !!(elemement.getContext && elemement.getContext("2d"))
}

// this working code snippet is taken from - https://github.com/artem0/canvas-fingerprinting/blob/master/fingerprinting/fingerprint.js
const getCanvasFingerprint = () => {
    if (!isCanvasSupported()) {
        return "nocanvasprint"
    }

    const canvas = document.createElement("canvas")
    const context = canvas.getContext("2d")
    if (!context) {
        return "nocanvas"
    }

    // https://www.browserleaks.com/canvas#how-does-it-work
    const txt = "FireAi@20221123"
    context.textBaseline = "top"
    context.font = "14px 'Arial'"
    context.textBaseline = "alphabetic"
    context.fillStyle = "#f60"
    context.fillRect(125, 1, 62, 20)
    context.fillStyle = "#069"
    context.fillText(txt, 2, 15)
    context.fillStyle = "rgba(102, 204, 0, 0.7)"
    context.fillText(txt, 4, 17)

    return canvas.toDataURL()
}

export const getBrowserFingerprint = () => {
    // @todo -- in the future, try out the audio aspect as well
    const canvasId = SHA256(getCanvasFingerprint()).toString()

    return canvasId
}
